import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// env
import { environment } from 'src/environments/environment';

// libs Modules
import { QRCodeModule } from 'angularx-qrcode';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';

// custom modules
import { SharedModule } from 'src/app/shared.modules/shared.module';
import { AdsManagementRoutingModule } from './ads-management-routing.module';
import { PaymentModule } from 'src/app/shared.system.modules/payment/payment.module';

// main components
import { AdsManagementComponent } from './ads-management.component';

// child components
import { BookingsComponent } from './bookings/bookings.component';
import { buildAdsComponent } from './build-ads/build-ads.component';
import { AdvertiserClassComponent } from './advertiser-class/advertiser-class.component';

// ViewAdsComponent
import { ViewAdsComponent } from './shared.components/view-ads/view-ads.component';
import { RegaAdDataComponent } from './shared.components/view-ads/components/rega-ad-data/rega-ad-data.component';
import { AdvertisementUnitsComponent } from './shared.components/view-ads/components/advertisement-units/advertisement-units.component';
import { AdvertisementDetailsComponent } from './shared.components/view-ads/components/advertisement-details/advertisement-details.component';
import { RelatedAdvertisementsComponent } from './shared.components/view-ads/components/related-advertisements/related-advertisements.component';
import { AdvertisementContractComponent } from './shared.components/view-ads/components/advertisement-contract/advertisement-contract.component';
import { AdvertisementPlanZonesComponent } from './shared.components/view-ads/components/advertisement-plan-zones/advertisement-plan-zones.component';
import { AdvertisementMapDetailsComponent } from './shared.components/view-ads/components/advertisement-map-details/advertisement-map-details.component';
import { AdvertisementExtraDetailsComponent } from './shared.components/view-ads/components/advertisement-extra-details/advertisement-extra-details.component';
import { AdvertisementDetailsSlidesComponent } from './shared.components/view-ads/components/advertisement-details-slides/advertisement-details-slides.component';
import { AdvertisementPaymentTimelineComponent } from './shared.components/view-ads/components/advertisement-payment-timeline/advertisement-payment-timeline.component';
import { AdvertisementProgressTimelineComponent } from './shared.components/view-ads/components/advertisement-progress-timeline/advertisement-progress-timeline.component';


// shared
import { TabsComponent } from 'src/app/shared.standalone/tabs/tabs.component';
import { BillDataComponent } from 'src/app/shared.standalone/bill-data/bill-data.component';
import { CheckBoxComponent } from "src/app/shared.standalone/check-box/check-box.component";
import { RadioButtonComponent } from 'src/app/shared.standalone/radio-button/radio-button.component';
import { OrderDetailsComponent } from 'src/app/shared.standalone/order-details/order-details.component';
import { PreviewAdDataComponent } from 'src/app/shared.standalone/preview-ad-data/preview-ad-data.component';
import { InfoCardModelComponent } from 'src/app/shared.standalone/info-card-model/info-card-model.component';
import { FileUploadFieldComponent } from 'src/app/shared.standalone/file-upload-field/file-upload-field.component';
import { AdvertisementCardComponent } from "src/app/shared.standalone/advertisement-card/advertisement-card.component";

/**
 * icons standalone
*/
import { LogoIconComponent } from "src/app/shared.standalone/icons/svg/logo-icon/logo-icon.component";
import { CoinsIconComponent } from "src/app/shared.standalone/icons/svg/coins-icon/coins-icon.component";
import { DrawerAltComponent } from "src/app/shared.standalone/icons/svg/drawer-alt/drawer-alt.component";
import { CloseIconComponent } from "src/app/shared.standalone/icons/svg/close-icon/close-icon.component";
import { CheckIconComponent } from "src/app/shared.standalone/icons/svg/check-icon/check-icon.component";
import { AddMediaIconComponent } from "src/app/shared.standalone/icons/svg/add-media-icon/add-media-icon.component";

// pipes
import { PriceHandlerPipe } from 'src/app/core/pipes/enmus/price-handler';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    // main
    AdsManagementComponent,

    // child shared
    ViewAdsComponent,
    buildAdsComponent,
    BookingsComponent,
    RegaAdDataComponent,
    AdvertiserClassComponent,
    AdvertisementUnitsComponent,
    AdvertisementDetailsComponent,
    AdvertisementContractComponent,
    RelatedAdvertisementsComponent,
    AdvertisementPlanZonesComponent,
    AdvertisementMapDetailsComponent,
    AdvertisementExtraDetailsComponent,
    AdvertisementDetailsSlidesComponent,
    AdvertisementPaymentTimelineComponent,
    AdvertisementProgressTimelineComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AdsManagementRoutingModule,
    /**
     * standalone shared Pipes
     */
    PriceHandlerPipe,
    /**
     * standalone shared components
    */
    TabsComponent,
    BillDataComponent,
    CheckBoxComponent,
    RadioButtonComponent,
    AddMediaIconComponent,
    OrderDetailsComponent,
    PreviewAdDataComponent,
    InfoCardModelComponent,
    FileUploadFieldComponent,
    AdvertisementCardComponent,
    /**
     * standalone icons
    */
    LogoIconComponent,
    DrawerAltComponent,
    CloseIconComponent,
    CoinsIconComponent,
    CheckIconComponent,
    /**
     * modules for libs
    */
    NgbModule,
    QRCodeModule,
    PaymentModule,
    NgSelectModule,
    GoogleMapsModule,
    NgxPaginationModule,
],
})
export class AdsManagementModule { }
